<template>
  <div data-v-73c11644="" data-v-e5781868="" class="messages-box mainContent top50" style="background: #fafafa;">
    <div data-v-73c11644="" class="content">
      <div data-v-73c11644="" class="title">
        <a href="javascript:void(0);" @click="$router.go(-1)"
          ><svg data-v-338e1447="" data-v-73c11644="" aria-hidden="true" class="svg-icon undo">
            <use data-v-338e1447="" xlink:href="#icon-undo"></use></svg
        ></a>
        消息中心
      </div>
      <div data-v-73c11644="" class="messages">
        <div data-v-73c11644="" class="topH">
          <div data-v-73c11644="" class="menu">
           
            <div data-v-73c11644="" @click="changType(0)" :class="type==0 ? 'btn active' : 'btn'">
              <span data-v-73c11644=""
                ><svg data-v-338e1447="" data-v-73c11644="" aria-hidden="true" class="svg-icon gift">
                  <use data-v-338e1447="" xlink:href="#icon-gift"></use></svg
                >消息通知</span
              >
            </div>
            <div data-v-73c11644="" @click="changType(1)" :class="type == 1 ? 'btn active' : 'btn'">
              <span data-v-73c11644=""
                ><svg data-v-338e1447="" data-v-73c11644="" aria-hidden="true" class="svg-icon blocks">
                  <use data-v-338e1447="" xlink:href="#icon-blocks"></use></svg
                >系统推送</span
              >
            </div>
          </div>
          
        </div>
        <div data-v-73c11644="" class="messageList" v-if="type == 0">
          <div data-v-73c11644="" class="item active" v-for="(item, index) in noticeList" :key="index">
            <h1 data-v-73c11644="">{{item.title}}</h1>
            <p data-v-73c11644="" v-html="item.content"></p>
            <div data-v-73c11644="" class="txt"><span data-v-73c11644="">{{item.created_at}}</span></div>
          </div>
 
          <div data-v-73c11644="" v-if="noticeList.length == 0" class="no-message"><i data-v-73c11644=""></i><span data-v-73c11644="">暂无消息通知</span></div>
        </div>
        <div data-v-73c11644="" class="messageList" v-if="type == 1">
          <div data-v-73c11644="" class="item active" v-for="(item, index) in homenoticelis" :key="index">
            <p data-v-73c11644="">{{item}}</p>
          </div>
   
          <div data-v-73c11644="" v-if="homenoticelis.length == 0"  class="no-message"><i data-v-73c11644=""></i><span data-v-73c11644="">暂无消息通知</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'accountSetting',
  data() {
    return { type: 0, noticeList: [], homenoticelis: [] };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.type = query.type*1;
      
    }
    that.$parent.showLoading();
    that.homenotice();
    that.getDatalist();
  },
  methods: {
    changType(val) {
      this.type = val;
    },
    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getDatalist() {
      let that = this;
      let page = that.page;
      that.$apiFun
        .post('/api/noticeList', { page })
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.noticeList = res.data.data;
            localStorage.setItem('show',1);
            that.$store.commit('changMessageNum');
          }
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.bannerSwiper .swiper', {
      slidesPerView: 'auto',
      pagination: {
        el: '.bannerSwiper .swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.bannerSwiper .swiper-button-next',
        prevEl: '.bannerSwiper .swiper-button-prev',
      },
    });
    var swiperList = new Swiper('.box .swiper-img', {
      navigation: {
        nextEl: '.swiper-img .swiper-button-next',
        prevEl: '.swiper-img .swiper-button-prev',
      },
    });
    var swiper = new Swiper('.k8BrandWay .c .timeline .swiper', {
      navigation: {
        nextEl: '.k8BrandWay .c .timeline .tool.next',
        prevEl: '.k8BrandWay .c .timeline .tool.prev',
      },
    });
    $('.k8BrandWay .c .timeline .swiper .swiper-slide .swiper-content .items .item').click(function () {
      $(this).addClass('active').siblings().removeClass('active');
      var u = $(this).index();
      var b = ((u + 1) / 7) * 100;
      console.log(b);
      $(this)
        .parents('.swiper-slide')
        .find('.swiper-content .line .activeState')
        .css('width', b + '%');
      var i = $(this).parents('.swiper-slide').index();
      if (i > 1) {
        for (var t = 0; t < i; t++) {
          if (t > 1) {
            $('.k8BrandWay .c .timeline .swiper .swiper-slide').eq(t).find('.swiper-content .line .activeState').css('width', '100%');
          }
        }
      }
      var m = i * 7;
      var o = m + u;
      swiperList.slideTo(o, 1000, false);
    });
    $('.table table tr').click(function () {
      $('.table table tr').removeClass('active');
      $(this).addClass('active');
      var username = $(this).find('td').eq(1).text();
      var amount = $(this).find('td').eq(2).text();
      $('.profit .user-name').text('会员' + username);
      $('.profit .amount h1').text(amount.replace('元', ''));
    });
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-6ba8d377.c378ea0a.css';
</style>



// WEBPACK FOOTER //
// src/components/mode/messages.vue